import React, { Component } from 'react';
class footer extends Component {

    render() {return <div className='footerText'>
        <p>Zhyar A. Jamal , All Rights Revered</p>
    </div>}}

    export default footer;